// This is pages/StockWatchlist.js
import React, { useContext, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useCallback } from 'react';
import { fetchMetrics } from '../api';
import WatchlistTable from '../components/WatchlistTable';
// import StockSearch from '../components/StockSearch';
import { WatchlistContext } from '../contexts/StockWatchlistContext';
// import '../styles.css';
import '../pages/StockWatchlist.css';
import { METRIC_FIELDS } from '../constants/metricFields';




// Available stock symbols
// const AVAILABLE_STOCKS = ['AAPL', 'GOOGL', 'MSFT', 'AMZN', 'TSLA'];

// Default metrics to display
// >>>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>
// Default metrics to display (using shared METRIC_FIELDS)
const DEFAULT_METRIC_KEYS = [
  'priceToEarningsRatio',
  'grossProfitMargin',
  'netProfitMargin'
];

const DEFAULT_METRICS = METRIC_FIELDS
  .filter(m => DEFAULT_METRIC_KEYS.includes(m.value))
  .map(m => ({ ...m, key: m.value }));
  
// <<<<<<<<<<<<<

export default function StockWatchlist() {

  const auth = useAuth();
  // const [pendingSave, setPendingSave] = useState(null);



  const { symbols: watchlistStocks, remove: removeFromWatchlist } = useContext(WatchlistContext);



 const [compareSelection, setCompareSelection] = useState([]);

 
  // State for metrics data
  const [metricsData, setMetricsData] = useState({});
  // State for selected metrics
  const [selectedMetrics, setSelectedMetrics] = useState(DEFAULT_METRICS);
  // State for loading status
  const [loading, setLoading] = useState(false);

  // Fetch metrics for a stock when added to watchlist
    const fetchStockMetrics = useCallback(async (symbol) => {
        setLoading(true);
        try {
          const data = await fetchMetrics(symbol);
          if (data) {
            setMetricsData(prev => ({
              ...prev,
              [symbol]: data
            }));
          }
        } finally {
          setLoading(false);
        }
      }, []);

// eslint-disable-next-line react-hooks/exhaustive-deps 
          useEffect(() => {
            watchlistStocks.forEach(symbol => {
              if (!metricsData[symbol]) {
                fetchStockMetrics(symbol);
              }
            });
          }, [watchlistStocks, metricsData, fetchStockMetrics]);

  return (
    <div className="stock-watchlist-page">
      <h2>Stock Watchlist</h2>

            {!auth.isAuthenticated && (
        <div className="login-cta">
          <p>Sign Up or Log In here to save your watchlist.</p>
          <button

 onClick={() => {
     sessionStorage.setItem('pendingSave', JSON.stringify(watchlistStocks));
     sessionStorage.setItem('postLoginRedirect', '/watchlist');
     auth.signinRedirect();
   }}
               
            className="cta-button"
          >
            Sign In Here to Save Watchlist
          </button>
        </div>
      )}
      
      {/* Stock Search Component for testing */}
      {/* <StockSearch 
        availableStocks={AVAILABLE_STOCKS}
        addToWatchlist={addToWatchlist}
        watchlistStocks={watchlistStocks}
      /> */}

      {/* Watchlist Table Component */}
           {watchlistStocks.length > 0 ? (
      <>
       <WatchlistTable
         watchlistStocks={watchlistStocks}
         metricsData={metricsData}
         selectedMetrics={selectedMetrics}
         setSelectedMetrics={setSelectedMetrics}
         removeFromWatchlist={removeFromWatchlist}
         loading={loading}
         compareSelection={compareSelection}
         onToggleCompare={(symbol) =>
           setCompareSelection(prev =>
             prev.includes(symbol)
               ? prev.filter(s => s !== symbol)
               : [...prev, symbol]
           )
         }
       />


      </>
     ) : (
  
    
        <div className="empty-watchlist">
          <p>Your watchlist is empty. Search and add stocks above.</p>
        </div>
      )}

    </div>

    
  );
}